import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { amazoneAdsProcess } from "../../../../../services/marketPlaceConnection";
import Loading from "../Loading/Loading";
import AmazoneAdsCartView from "../AmazoneAdsCartView";
import Header from "../../../Header/Header";
import ErrorPage from "../ErrorPage/ErrorPage";
import AddonPreviewModal from "../../Razorpay/AddonPreviewModal";
import { useRazorpay } from "../../../../../context/RazorpayContext";
import RazorpayModal from "../../Razorpay/RazorpayModal";

const AmazonAdsCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { handleAddOnInvoicePreview, addonInvoicePreviewData, razorpayModalData } = useRazorpay();
  const [loading, setLoading] = useState(false);
  const [authData, setAuthData] = useState(null);
  const [isShowAmazonAdsCart, setIsShowAmazonAdsCart] = useState(false);
  const [isPreviewLoading, seIsPreviewLoading] = useState(false);
  const [needPayment, setNeedPayment] = useState(false);
  const afterPaymentSuccessNavigationUrl = '/marketplace-accounts';
  const onCancelPaymentNavigationUrl = '/marketplace-accounts';
  
  useEffect(() => {
    const auth_code = searchParams.get("code");
    const scope = searchParams.get("scope");

    if (auth_code && scope) {
      (async () => {
        setLoading(true);
        window.history.replaceState(null, "", "/");
        try {
          const res = await amazoneAdsProcess({
            auth_code,
            scope,
          });
          if (res.success) {
            setLoading(false);
            setAuthData(res.data);
            setIsShowAmazonAdsCart(true);
            localStorage.setItem("need_marketplace_account", false);
          } else {
            console.error("Amazon auth process failed", res);
          }
        } catch (err) {
          setLoading(false);
          console.error("Error processing Amazon auth:", err);
        }
      })();
    } else {
      navigate("/marketplace-accounts");
    }
  }, [searchParams]);

  const handleDone = async (ids,needPayment) => {
    if (!needPayment) {
      navigate("/marketplace-accounts");
    }
    else {
      const idsArray = ids.map((item) => item.id)
      seIsPreviewLoading(true);
      await handleAddOnInvoicePreview(seIsPreviewLoading, idsArray);
    }
  };

  return (
    <>
      {addonInvoicePreviewData?.isOpenModal && (
        <AddonPreviewModal
          accountType={"amazonAds"}
          setShowPage={setIsShowAmazonAdsCart}
          onCancelPaymentNavigationUrl={onCancelPaymentNavigationUrl}
        />
      )}
      {razorpayModalData?.isRazorPayModal && (
        <RazorpayModal navigationUrl={afterPaymentSuccessNavigationUrl} />
      )}

      {loading && (
        <Loading
          image="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg"
          text="Connecting your Amazon account..."
        />
      )}

      {isShowAmazonAdsCart && (
        <>
          <Header />
          <AmazoneAdsCartView authData={authData} onDone={handleDone} />
        </>
      )}
    </>
  );
};

export default AmazonAdsCallback;
